/**
 * Selects the appropriate popup mailer based on current URL and targeting rules
 * @param {Array} popupMailers - Array of available popup mailers
 * @param {string} currentPath - Current page path (e.g., '/collections/summer')
 * @returns {Object} Selected mailer object
 */
export function selectMailer(popupMailers, currentPath) {
  if (!popupMailers || popupMailers.length === 0) {
    return null;
  }

  // Check if we're on a UK locale page
  const isUKLocale = currentPath.includes('/gb/');

  if (isUKLocale) {
    if ( popupMailers.find(mailer => mailer.targeting.showOnUrls.includes('/gb/'))) {
      return popupMailers.find(mailer => mailer.targeting.showOnUrls.includes('/gb/'));
    } else if ( popupMailers.find(mailer => mailer.targeting.showOnUrls.includes('/gb'))) {
      return popupMailers.find(mailer => mailer.targeting.showOnUrls.includes('/gb'));
    }
  }
  
  // Look for a mailer that matches the current URL
  let selectedMailer = popupMailers.find(mailer => mailer.targeting.showOnUrls.includes('default')); // Default to first mailer
  
  for (const mailer of popupMailers) {
    if (mailer?.targeting?.showOnUrls?.length > 0) {
      // Check if any of the showOnUrls patterns match the current URL
      const matchesUrl = mailer.targeting.showOnUrls.some(urlPattern => {
        try {
          const regex = new RegExp(urlPattern);
          return regex.test(currentPath);
        } catch (error) {
          console.error('Invalid regex pattern in mailer targeting:', urlPattern);
          return false;
        }
      });
      
      if (matchesUrl) {
        selectedMailer = mailer;
        console.log('Found URL-specific mailer:', mailer.title);
        break;
      }
    }
  }

  
  return selectedMailer;
}
